import {SEARCHMODE} from './store-locator.mjs';

/**
 * Postal code form handlers
 */
export function initPostalCodeForm(container, {onsuccess, onfailure} = {}) {
  // 'slocpc' stands for Store LOCator Postal Code
  const form      = container.querySelector('.js-slocpc-form');
  const submitBtn = container.querySelector('.js-slocpc-submit');
  const inputPC   = container.querySelector('input[name=postalcode]');
  const inputGEO  = container.querySelector('input[name=geolocation]');

  inputPC.dataset.placeholderNormal = inputPC.placeholder;
  inputPC.addEventListener('input', event => {
    // Cancel geolocation mode as soon as the user types something in the field.
    inputPC.placeholder = inputPC.dataset.placeholderNormal;
    inputPC.required = true;
    inputGEO.value = '';

    if (inputPC.validity.patternMismatch) {
      inputPC.setCustomValidity(inputPC.dataset.invalidPattern);
    }
    else {
      // Prettify output
      inputPC.value = inputPC.value.toUpperCase();
      if (inputPC.value.length == 6) inputPC.value = inputPC.value.slice(0, 3) + ' ' + inputPC.value.slice(-3);
      inputPC.setCustomValidity('');
    }
  });

  // Geolocation button

  const AWAITING = 'AWAITING';

  // A click on the geolocation triggers the form submission immediately.
  container.querySelector('.js-slocpc-geolocation').addEventListener('click', event => {
    event.preventDefault();

    inputPC.value = '';
    inputPC.placeholder = inputPC.dataset.placeholderGeoloc;
    inputPC.setCustomValidity('');
    inputPC.removeAttribute('required');

    inputGEO.value = AWAITING;
    submitBtn.click();
  });

  submitBtn.addEventListener('click', async event => {
    // Reset geolocation validation message, as it will be re-tested in the submit handler.
    if (inputPC.validationMessage === inputPC.dataset.invalidGeolocfailed) inputPC.setCustomValidity('');
  });

  form.addEventListener('submit', async event => {
    event.preventDefault();

    submitBtn.classList.replace('btn--chevron', 'btn--loading');

    if (inputGEO.value) {
      let coords;
      // Get location info just in time.
      try {
        coords = (await Promutuel.geolocation.getCurrentPosition()).coords;
        inputGEO.value = `${coords.latitude},${coords.longitude}`;
      }
      catch (error) {
        console.error(error);
        inputPC.setCustomValidity(inputPC.dataset.invalidGeolocfailed);
        inputPC.reportValidity();
        submitBtn.classList.replace('btn--loading', 'btn--chevron');
        return false;
      }

      try {
        const data = await Promutuel.mutuals.lookupByLocation(coords);
        if (onsuccess) onsuccess(data, SEARCHMODE.GEO);
      }
      catch (err) {
        console.log(err);
        if (onfailure) onfailure(err, SEARCHMODE.GEO);
      }
    }
    else {
      try {
        const data = await Promutuel.mutuals.lookupByPostalCode(inputPC.value)
        if (onsuccess) onsuccess(data, SEARCHMODE.POSTAL);
      }
      catch(err) {
        console.log(err);
        if (onfailure) onfailure(err, SEARCHMODE.POSTAL);
      }
    }

    submitBtn.classList.replace('btn--loading', 'btn--chevron');
  });
}
